import { Link } from "react-router-dom";
import { useSeo } from "../lib/hooks";

export default function NotFound() {
  useSeo({ title: "Page introuvable" });
  return (
    <div className="max-w-xl mx-auto px-5 py-32 text-center" data-testid="not-found-page">
      <p className="eyebrow">Erreur 404</p>
      <h1 className="font-display text-5xl mt-4">Cette page s'est évaporée</h1>
      <Link to="/" className="btn-gold mt-10">Retour à l'accueil</Link>
    </div>
  );
}
